/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_HeadingInputs */

const en_reading_class_heading = /** @type {(inputs: Reading_Class_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headings`)
};

const es_reading_class_heading = /** @type {(inputs: Reading_Class_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Títulos`)
};

/**
* | output |
* | --- |
* | "Headings" |
*
* @param {Reading_Class_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_heading = /** @type {((inputs?: Reading_Class_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_heading(inputs)
	return en_reading_class_heading(inputs)
});